import React, { useState } from 'react';
import {
  Grid, makeStyles, TextField, Typography, Button, useMediaQuery, Checkbox
} from '@material-ui/core';
import {
  Check as CheckIcon
} from '@material-ui/icons';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';

const useStyle = makeStyles(theme => ({
  jumbotron: {
    backgroundColor: 'rgb(48, 48, 48)',
    padding: 50,
    textAlign: 'center'
  },
  logoHolder: {
    backgroundColor: '#fff',
    overflow: 'hidden',
    marginBottom: 30
  },
  subHeading: {
    color: 'rgb(127, 176, 255)',
    marginTop: 5
  },
  section: {
    padding: 50
  },
  sectionLeftHeading: {
    color: 'rgb(47, 47, 47)',
    fontWeight: 600
  },
  formContainer: {
    border: '3px solid rgb(47, 47, 47)',
    dispaly: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    textAlign: 'center',
    padding: '40px 60px',
    width: 600,
    '& p, h4, div, button': {
      marginTop: 10
    },
    '& h4, h5': {
      fontWeight: 600,
      color: 'rgba(47, 47, 47)'
    }
  },
  button: {
    backgroundColor: 'rgb(207, 73, 22)',
    padding: 10,
    fontWeight: 600,
    // marginLeft: '10px !important',
    '&:hover': {
      backgroundColor: '#aa3c12'
    }
  },
  footer: {
    marginTop: 5,
    padding: 35,
    paddingBottom: 40,
    textAlign: 'center',
    backgroundColor: '#f1f4f8',
    borderTop: '4px solid #eeeeee',
    position: 'relative',
    bottom: 0
  },
  sectionLeftContainer: {
    marginRight: 200,
    '& h3, p': {
      marginBottom: 10
    }
  },
  features: {
    '& p': {
      marginTop: 17,
      marginLeft: -5,
      fontWeight: 900,
      color: 'rgba(47, 47, 47, 0.86)',
      fontSize: 17
    },
    '& p svg': {
      marginRight: 10
    }
  },
  upgradePlanContainer: {
    border: '2px dashed brown',
    padding: 5,
    backgroundColor: '#fcf8db',
    width: '100%'
  },
  oneTimeOffer: {
    fontWeight: 600,
    textDecoration: 'underline',
    color: '#88482d'
  }
}));

const isValidEmail = (email) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);

const Lifetime = () => {
  const [state, setStateFun] = useState({
    name: '',
    email: '',
    upgradePlan: false
  });
  const setState = (obj) => setStateFun(state => ({ ...state, ...obj }));

  const matches = useMediaQuery('(max-width:1000px)')
  const navigate = useNavigate();
  const classes = useStyle();

  const onChange = (e) => {
    setState({
      [e.target.name]: e.target.value
    })
  }

  const onSubmit = async () => {
    setState({ saving: true, error: '' });

    try {
      const AUHT_BASE_URL = 'https://api.postplan.io/auth';
      // const AUHT_BASE_URL = 'https://y3rzqzg5vg.execute-api.ap-south-1.amazonaws.com/dev';

      const selectedPlan = {
        appName: 'publish',
        planType: state.upgradePlan ? 'freelancer' : 'personal',
        billingPeriod: 'lifetime',
        currency: 'usd'
      }

      const { data: user } = await axios.post(`${AUHT_BASE_URL}/funnel-user`, {
        name: state.name,
        email: state.email,
        selectedPlan
      });

      // localStorage.setItem('user', JSON.stringify({
      //   id: user.id,
      //   name: state.name,
      //   email: state.email
      // }));
      // localStorage.setItem('upgradePlan', state.upgradePlan);

      // navigate(`engage`);


      const { data: userData } = await axios.post(`${AUHT_BASE_URL}/signup`, {
        name: state.name,
        email: state.email,
        password: Math.random().toString(36).substr(2, 9),
        is_funnel_user: true,
        selected_plan: selectedPlan
      });

      const loginToken = userData.token;

      let appName = 'publish', planType = 'personal', currency = 'usd', billingPeriod = 'lifetime';

      if (state.upgradePlan && state.addEngage) {
        appName = 'publish_manage';
        planType = 'freelancer';
      } else if (state.addEngage) {
        appName = 'publish_manage';
      } else if (state.upgradePlan) {
        planType = 'freelancer';
      }

      // const STRIPE_BASE_URL = 'https://9dic51w2eh.execute-api.ap-south-1.amazonaws.com/dev';
      const STRIPE_BASE_URL = 'https://api.postplan.io/stripe-checkout';
      
      const { data: session } = await axios.get(`${STRIPE_BASE_URL}/create-checkout-session/${appName}/${planType}/${currency}/${billingPeriod}?loginToken=${loginToken}&isFunnelUser=true`, {
        headers: {
          'x-auth-token': loginToken
        }
      });

      const stripe = await loadStripe('pk_live_51HkVARLIprUPltei505pl7qNscuIpETD9OL6oldflZ55t8gyaWLCoadyZd5HsBEXLzqha4UL4rDkubsTcJTzGMME00KTU2ZCMb');
      // const stripe = await loadStripe('pk_test_51HkVARLIprUPlteiFjlifobiBKmxpwFYGerRaSHb1cNdqDb2FCFxqZI8fNXLURtnv01ChyU1uPVhxXSfZByv76Wd00cVocJUMV');

      stripe.redirectToCheckout({ sessionId: session.id });
    } catch (error) {
      setState({ error: typeof error?.response?.data === 'string' ? error?.response?.data : 'Something went wrong. Please try again.'});
      console.log('error', error)
    }

    setState({ saving: false });
  }

  const isRequiredFieldFilled = () => state.name && isValidEmail(state.email);

  return (
    <Grid container style={{ height: '100vh' }}>
      <Grid item xs={12} className={classes.jumbotron}>
        <div className="flex flex-column flex-center flex-middle">
          <div className={classes.logoHolder}>
            <img src="https://images.postplan.io/logo.png" alt="postplan-logo" height="100" />
          </div>
          <Typography variant={matches ? 'h4' : 'h3'} className="text-white">Schedule Unlimited Posts on Social Media</Typography>
          <Typography className={classes.subHeading} variant={matches ? 'h6' : 'h5'}>
            Unlimited Direct Scheduling to Instagram, Facebook, Twitter & LinkedIn
          </Typography>
        </div>
      </Grid>
      <Grid item xs={12} className={classes.section}>
        <div className="flex flex-center flex-middle" style={{
          flexDirection: matches ? 'column' : 'row'
        }}>
          <div className={classes.sectionLeftContainer} style={matches ? {
            marginRight: 0,
            alignSelf: 'flex-start'
          } : {}}>
            <Typography variant={matches ? 'h4' : 'h3'} className={classes.sectionLeftHeading}>
              Social Media <br /> Automation Tool
            </Typography>
            <Typography style={{ color: 'rgba(47, 47, 47, 0.7)', fontSize: matches ? 18 : 20 }}>
              Connect up to {state.upgradePlan ? 12 : 4} Social Media Accounts
            </Typography>
            <div className={classes.features}>
              <Typography className="flex flex-middle">
                <CheckIcon /> Direct Instagram Scheduling
              </Typography>
              <Typography className="flex flex-middle">
                <CheckIcon /> Tailored Posts for Each Social Network
              </Typography>
              <Typography className="flex flex-middle">
                <CheckIcon /> Unlimited Media Cloud Storage
              </Typography>
              <Typography className="flex flex-middle">
                <CheckIcon /> Schedule First Comment
              </Typography>
              <Typography className="flex flex-middle">
                <CheckIcon /> And So Much More...
              </Typography>
            </div>
          </div>
          <div className={classes.formContainer} style={matches ? {
            width: '95vw',
            padding: 15,
            paddingRight: 35,
            marginTop: 20
          } : {}}>
            <Typography variant={matches ? 'h5' : 'h4'}>
              Lifetime Access for {state.upgradePlan ? (
                <span><del>$999</del> $49</span>
              ) : (
                <span><del>$599</del> $29</span>
              )}!
            </Typography>
            <Typography style={{ color: 'rgba(47, 47, 47, 0.7)', fontSize: 19 }}>Enter Your Name & Email Below</Typography>
            <Typography style={{ color: 'red', fontSize: 14 }}>{state.error}</Typography>
            <TextField variant="outlined" name="name" value={state.name} onChange={onChange} fullWidth placeholder="Enter Your Full Name..." />
            <TextField
              variant="outlined"
              name="email"
              value={state.email}
              onChange={onChange}
              fullWidth
              placeholder="Enter Your Email Address..."
              error={state.email ? isValidEmail(state.email) : false}
              helperText={state.email && (isValidEmail(state.email) ? '' : 'Invalid email address')} />
            <div className={classes.upgradePlanContainer}>
              <div className="flex flex-middle" style={{ backgroundColor: 'rgb(238 239 184)' }}>
                <Checkbox checked={state.upgradePlan} onChange={() => setState({ upgradePlan: !state.upgradePlan })} />
                <Typography style={{ fontWeight: 600, fontSize: 18, color: 'rgb(40 107 35)' }}>Yes, I will Take It!</Typography>
              </div>
              <Typography style={{ textAlign: 'left' }}>
                <span className={classes.oneTimeOffer}>ONE TIME OFFER:</span> <span>Upgrade to 12 social media accounts in just $20</span>
              </Typography>
            </div>
            <Button variant="contained" color="primary" fullWidth className={classes.button} onClick={onSubmit} disabled={state.saving || !isRequiredFieldFilled()}>
              Get Lifetime Access Now
            </Button>
            <Typography style={{ color: 'rgba(47, 47, 47, 0.6)', fontSize: 13.5 }}>* we will not spam, rent, or sell your information *</Typography>
          </div>
        </div>
      </Grid>
      <Grid item xs={12} className={classes.footer}>
        <Typography style={{ color: 'rgba(47, 47, 47, 0.4)', fontSize: 19 }}>
          Copyright @ Post Plan - All Rights Reserved
        </Typography>
      </Grid>
    </Grid >
  );
}

export default Lifetime;